import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useApi from "./useApi";
import { toast } from "react-toastify";
import { IconButton, Modal, Box, Typography, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const Documents = () => {
    const { projectId, packageId, subcontractorId } = useParams();
    const [file, setFile] = useState(null);
    const [{ data: documents, loading }, callApi] = useApi();
    const [openModal, setOpenModal] = useState(false);
    const [documentToDelete, setDocumentToDelete] = useState(null);

    useEffect(() => {
        callApi({
            url: `/api/projects/${projectId}/packages/${packageId}/subcontractors/${subcontractorId}/documents`,
        });
    }, [projectId, packageId, subcontractorId, callApi]);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUploadDocument = (e) => {
        e.preventDefault();
        if (!file) {
            toast.error("Please select a file to upload.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        callApi({
            url: `/api/projects/${projectId}/packages/${packageId}/subcontractors/${subcontractorId}/documents`,
            method: "POST",
            body: formData,
        })
            .then(() => {
                toast.success("Document uploaded successfully!");
                setFile(null);
                callApi({
                    url: `/api/projects/${projectId}/packages/${packageId}/subcontractors/${subcontractorId}/documents`,
                });
            })
            .catch(() => {
                toast.error("Failed to upload document.");
            });
    };

    const handleOpenModal = (documentId) => {
        setDocumentToDelete(documentId);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleDeleteDocument = () => {
        callApi({
            url: `/api/projects/${projectId}/packages/${packageId}/subcontractors/${subcontractorId}/documents/${documentToDelete}`,
            method: "DELETE",
        })
            .then(() => {
                toast.success("Document deleted successfully!");
                setOpenModal(false);
                callApi({
                    url: `/api/projects/${projectId}/packages/${packageId}/subcontractors/${subcontractorId}/documents`,
                }); // Re-fetch documents
            })
            .catch(() => {
                toast.error("Failed to delete document.");
                setOpenModal(false);
            });
    };

    return (
        <div className="content-container">
            <h2>Documents for Subcontractor {subcontractorId}</h2>
            {loading && <div>Loading...</div>}
            <form onSubmit={handleUploadDocument} className="form-container">
                <input
                    type="file"
                    onChange={handleFileChange}
                    className="form-input"
                />
                <button type="submit" className="form-button">
                    Upload Document
                </button>
            </form>
            <ul className="item-list">
                {Array.isArray(documents) ? (
                    documents.map((document) => (
                        <li key={document.id} className="list-item">
                            <Link
                                to={`/projects/${projectId}/packages/${packageId}/subcontractors/${subcontractorId}/documents/${document.id}`}
                                className="item-link"
                            >
                                {document.name}
                            </Link>
                            <IconButton
                                onClick={() => handleOpenModal(document.id)}
                                size="small"
                            >
                                <DeleteIcon />
                            </IconButton>
                        </li>
                    ))
                ) : (
                    <p>No documents found.</p>
                )}
            </ul>
            {/*<Link*/}
            {/*    to={`/projects/${projectId}/packages/${packageId}/subcontractors/${subcontractorId}/summary`}*/}
            {/*    className="form-button"*/}
            {/*>*/}
            {/*    Generate Summary*/}
            {/*</Link>*/}
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="modal">
                    <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                    >
                        Confirm Deletion
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        Are you sure you want to delete this document?
                    </Typography>
                    <Button onClick={handleDeleteDocument} color="error">
                        Delete
                    </Button>
                    <Button onClick={handleCloseModal}>Cancel</Button>
                </Box>
            </Modal>
        </div>
    );
};

export default Documents;
